import { sortType, InputTypes } from '@bento-core/facet-filter';

const DEMOGRAPHICS = 'Demographics'; 
const STUDY = 'Study';
const DATA_ACCESS = 'Data Access';
const SAMPLES = 'Samples';
const GENOMIC = 'Genomic'; 
const IMAGING = 'Imaging';
const DIAGNOSIS = 'Diagnosis';
const FILES = 'Files';
const PROTEOMIC = 'Proteomic';
const CANCER_NANOTECHNOLOGY = 'Cancer Nanotechnology';

// --------------- Facet resetIcon link configuration --------------
// Ideal size for resetIcon is 16x16 px
export const resetIcon = {
  src: 'https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/bento/images/icons/svgs/Clear-icon.svg',
  alt: 'Reset icon',
  size: '11.5px',
};

// --------------- Dashboard Sidebar Sections styling --------------
export const facetSectionVariables = {
  Demographics: {
    isExpanded: true,
    hasSearch: true,
  },
  Study: {
    isExpanded: true,
  },
  "Data Access": {
    isExpanded: true,
  },
  Samples: {
    isExpanded: true,
  },
  Genomic: {
    isExpanded: true,
  },
  Imaging: {
    isExpanded: true,
  },
  Diagnosis: {
    isExpanded: true,
  },
  Files: {
    isExpanded: true,
  },
  Extra: {
    isExpanded: true,
  },
  Proteomic: {
    isExpanded: true,
  },
  "Cancer Nanotechnology": {
    isExpanded: true,
  }
};

export const facetsConfig = [
  // DEMOGRAPHICS
  {
    section: DEMOGRAPHICS,
    label: "Sex",
    apiPath: "filterSubjectCountBySex",
    apiForFiltering: "filterSubjectCountBySex",
    datafield: "sex",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  // STUDY
  {
    section: STUDY,
    label: "Study Name",
    apiPath: "filterSubjectCountByStudy",
    apiForFiltering: "filterSubjectCountByStudy",
    datafield: "studies",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    disableSearchModal: true,
    searchPlaceholder: "e.g. Study Name",
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: STUDY,
    label: "PHS Accession",
    apiPath: "filterSubjectCountByPhsAccession",
    apiForFiltering: "filterSubjectCountByPhsAccession",
    datafield: "phs_accession",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    disableSearchModal: true,
    searchPlaceholder: "e.g. phs000000",
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: STUDY,
    label: "Study Data Types",
    apiPath: "filterSubjectCountByStudyDataType",
    apiForFiltering: "filterSubjectCountByStudyDataType",
    datafield: "study_data_types",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: STUDY,
    label: "Experimental Strategy",
    apiPath: "filterSubjectCountByExperimentalStrategy",
    apiForFiltering: "filterSubjectCountByExperimentalStrategy",
    datafield: "experimental_strategies",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: STUDY,
    label: "Num Of Study Participants",
    apiPath: "filterSubjectCountByNumberOfStudyParticipants",
    apiForFiltering: "filterSubjectCountByNumberOfStudyParticipants",
    datafield: "number_of_study_participants",
    ApiLowerBoundName: "lowerBound",
    ApiUpperBoundName: "upperBound",
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: sortType.NONE,
    minLowerBound: 0,
    maxUpperBound: 25445,
    quantifier: "Study Participants",
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  //DATA ACCESS
  {
    section: DATA_ACCESS,
    label: "Access Type",
    apiPath: "filterSubjectCountByAccess",
    apiForFiltering: "filterSubjectCountByAccess",
    datafield: "accesses",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  //SAMPLES
  {
    section: SAMPLES,
    label: "Sample Tumor Status",
    apiPath: "filterSubjectCountByIsTumor",
    apiForFiltering: "filterSubjectCountByIsTumor",
    datafield: "is_tumor",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: SAMPLES,
    label: "sample type",
    apiPath: "filterSubjectCountBySampleType",
    apiForFiltering: "filterSubjectCountBySampleType",
    datafield: "sample_types",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: SAMPLES,
    label: "Num Of Study Samples",
    apiPath: "filterSubjectCountByNumberOfStudySamples",
    apiForFiltering: "filterSubjectCountByNumberOfStudySamples",
    datafield: "number_of_study_samples",
    ApiLowerBoundName: "lowerBound",
    ApiUpperBoundName: "upperBound",
    show: true,
    slider: true,
    type: InputTypes.SLIDER,
    sort_type: sortType.NONE,
    minLowerBound: 0,
    maxUpperBound: 40872,
    quantifier: "Study Samples",
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: SAMPLES,
    label: "Organization Name",
    apiPath: "filterSubjectCountByOrganizationName",
    apiForFiltering: "filterSubjectCountByOrganizationName",
    datafield: "organization_name",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: false,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  // GENOMIC
  {
    section: GENOMIC,
    label: "Library Strategy",
    apiPath: "filterSubjectCountByLibraryStrategy",
    apiForFiltering: "filterSubjectCountByLibraryStrategy",
    datafield: "library_strategies",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: GENOMIC,
    label: "Library Source Material",
    apiPath: "filterSubjectCountByLibrarySourceMaterial",
    apiForFiltering: "filterSubjectCountByLibrarySourceMaterial",
    datafield: "library_source_materials",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: GENOMIC,
    label: "Library Source Molecule",
    apiPath: "filterSubjectCountByLibrarySourceMolecule",
    apiForFiltering: "filterSubjectCountByLibrarySourceMolecule",
    datafield: "library_source_molecules",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: GENOMIC,
    label: "Library Layout",
    apiPath: "filterSubjectCountByLibraryLayout",
    apiForFiltering: "filterSubjectCountByLibraryLayout",
    datafield: "library_layouts",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: GENOMIC,
    label: "Library Selection",
    apiPath: "filterSubjectCountByLibrarySelection",
    apiForFiltering: "filterSubjectCountByLibrarySelection",
    datafield: "library_selections",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: GENOMIC,
    label: "Platform",
    apiPath: "filterSubjectCountByPlatform",
    apiForFiltering: "filterSubjectCountByPlatform",
    datafield: "platforms",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: GENOMIC,
    label: "Instrument Model",
    apiPath: "filterSubjectCountByInstrumentModel",
    apiForFiltering: "filterSubjectCountByInstrumentModel",
    datafield: "instrument_models",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: GENOMIC,
    label: "Reference Genome Assembly",
    apiPath: "filterSubjectCountByReferenceGenomeAssembly",
    apiForFiltering: "filterSubjectCountByReferenceGenomeAssembly",
    datafield: "reference_genome_assemblies",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  // IMAGING
  {
    section: IMAGING,
    label: "Image Modality",
    apiPath: "filterSubjectCountByImageModality",
    apiForFiltering: "filterSubjectCountByImageModality",
    datafield: "image_modality",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: IMAGING,
    label: "Tissue Fixative",
    apiPath: "filterSubjectCountByTissueFixative",
    apiForFiltering: "filterSubjectCountByTissueFixative",
    datafield: "tissue_fixative",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: IMAGING,
    label: "Imaging Assay Type",
    apiPath: "filterSubjectCountByImagingAssayType",
    apiForFiltering: "filterSubjectCountByImagingAssayType",
    datafield: "imaging_assay_type",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: IMAGING,
    label: "Tissue Or Organ Of Origin",
    apiPath: "filterSubjectCountByOrganOrTissue",
    apiForFiltering: "filterSubjectCountByOrganOrTissue",
    datafield: "organ_or_tissue",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  // DIAGNOSIS
  {
    section: DIAGNOSIS,
    label: "Primary Diagnosis",
    apiPath: "filterSubjectCountByPrimaryDiagnosis",
    apiForFiltering: "filterSubjectCountByPrimaryDiagnosis",
    datafield: "primary_diagnoses",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    disableSearchModal: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
    //searchPlaceholder: "Customize Placeholder Text",
  },
  // FILES
  {
    section: FILES,
    label: "File Type",
    apiPath: "filterSubjectCountByFileType",
    apiForFiltering: "filterSubjectCountByFileType",
    datafield: "file_types",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    search: true,
    disableSearchModal: true,
    searchPlaceholder: "e.g. BAM",
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: FILES,
    label: "Is Supplementary File",
    apiPath: "filterSubjectCountByIsSupplementaryFile",
    apiForFiltering: "filterSubjectCountByIsSupplementaryFile",
    datafield: "is_supplementary_file",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  // PROTEOMIC
  {
    section: PROTEOMIC,
    label: "Analytical Fractions",
    apiPath: "filterSubjectCountByAnalyticalFractions",
    apiForFiltering: "filterSubjectCountByAnalyticalFractions",
    datafield: "analytical_fractions",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  {
    section: PROTEOMIC,
    label: "Instrument Makes",
    apiPath: "filterSubjectCountByInstrumentMakes",
    apiForFiltering: "filterSubjectCountByInstrumentMakes",
    datafield: "instrument_makes",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
    customCount: (val) => `(${Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(val || 0)})`,
  },
  // Cancer Nanotechnology
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Protocol Name",
    apiPath: "filterSubjectCountByProtocolName",
    apiForFiltering: "filterSubjectCountByProtocolName",
    datafield: "protocol_names",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Protocol Type",
    apiPath: "filterSubjectCountByProtocolType",
    apiForFiltering: "filterSubjectCountByProtocolType",
    datafield: "protocol_types",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "DOI",
    apiPath: "filterSubjectCountByDoi",
    apiForFiltering: "filterSubjectCountByDoi",
    datafield: "dois",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Publication Title",
    apiPath: "filterSubjectCountByPublicationTitle",
    apiForFiltering: "filterSubjectCountByPublicationTitle",
    datafield: "publication_titles",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Publication Status",
    apiPath: "filterSubjectCountByPublicationStatus",
    apiForFiltering: "filterSubjectCountByPublicationStatus",
    datafield: "publication_statuses",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: false,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Nanomaterial Entity",
    apiPath: "filterSubjectCountByNanomaterialEntity",
    apiForFiltering: "filterSubjectCountByNanomaterialEntity",
    datafield: "nanomaterial_entities",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Functionalizing Entity",
    apiPath: "filterSubjectCountByFunctionalizingEntity",
    apiForFiltering: "filterSubjectCountByFunctionalizingEntity",
    datafield: "functionalizing_entities",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Characterization Type",
    apiPath: "filterSubjectCountByCharacterizationType",
    apiForFiltering: "filterSubjectCountByCharacterizationType",
    datafield: "characterization_types",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
  {
    section: CANCER_NANOTECHNOLOGY,
    label: "Characterization Name",
    apiPath: "filterSubjectCountByCharacterizationName",
    apiForFiltering: "filterSubjectCountByCharacterizationName",
    datafield: "characterization_names",
    field: "group",
    type: InputTypes.CHECKBOX,
    sort_type: sortType.ALPHABET,
    show: true,
  },
];

// --------------- Dashboard Widgets configuration --------------
// Sunburst chart color scheme
export const SUNBURST_COLORS_LEVEL_1 = [
  '#7dc242',
  '#274fa5',
  '#79287c',
  '#f78f48',
  '#057ebd',
];

export const SUNBURST_COLORS_LEVEL_2 = [
  '#057ebd',
  '#f78f48',
  '#79287c',
  '#0e3151',
  '#057ebd',
  '#7dc242',
];

// A maximum of 6 widgets are allowed
// for donuts only the following are required: type, title, dataName
//
// type: 'sunburst' | 'donut'
// title: string
// dataName: string
// datatable_level1_field: string
// datatable_level1_colors: string[]
// datatable_level2_field: string
// datatable_level2_colors: string[]
// sliceTitle: string (optional)
export const widgetConfig = [
  {
    type: 'donut',
    title: 'Experimental Strategy',
    dataName: 'donutCountByExperimentalStrategy',
    sliceTitle: 'Files',
  },
  {
    type: 'donut',
    title: 'Sex',
    dataName: 'donutCountBySex',
    sliceTitle: 'Participants',
  },
  {
    type: 'donut',
    title: 'File Type',
    dataName: 'donutCountByFileType',
    sliceTitle: 'Files',
  },
  {
    type: 'donut',
    title: 'Study Data Types',
    dataName: 'donutCountByStudyDataTypes',
    sliceTitle: 'Files',
  },
  {
    type: 'donut',
    title: 'Image Modality',
    dataName: 'donutCountByImageModality',
    sliceTitle: 'Files',
  },
  {
    type: 'donut',
    title: 'Sample Type',
    dataName: 'donutCountBySampleType',
    sliceTitle: 'Samples',
  },
];
